import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

export const Route = createFileRoute("/_authenticated/_financials/rent-roll")({
  beforeLoad: ({ context }) => guardRoute(context.me, "rent-roll"),
  component: Outlet,
});
